import type { Quote } from '../../types/quotes/quote'
import type { RelatedInvoice } from '../../types/relatedInvoice'
import { isDepositInvoice } from './isDepositInvoice'

export const getQuoteDepositInvoice = (quote?: Quote): RelatedInvoice | undefined =>
  quote?.relatedInvoices?.find((relatedInvoice) => isDepositInvoice(relatedInvoice.billingStage))
